/* eslint-disable no-console */
import { decimalFormatter } from '../helper';

const dic_win = {
  '°C': [1.0, 0, '°C'],
  '°F': [0.55555555, -17.77777777, '°C'],
  'atm': [1.0, 0, 'atm'],
  'lbf/ft2': [0.000472541, 0, 'atm'],
  'psi': [0.0680457267283615, 0, 'atm'],
  'ft H2O': [0.029499, 0, 'atm'],
  'in H2O': [0.00245586, 0, 'atm'],
  'in Hg': [0.0334210708117444, 0, 'atm'],
  'mm Hg': [0.00131578583765112, 0, 'atm'],
  'kgf/cm2': [0.967841105354059, 0, 'atm'],
  'kgf/m2': [9.6784110535406E-5, 0, 'atm'], // new unit for pressure by abhishek
  'bar': [0.986923266716013, 0, 'atm'],
  'kPa': [0.00986923266716013, 0, 'atm'],
  'MPa': [9.86923266716013, 0, 'atm'],
  'm3/s': [1.0, 0, 'm3/s'],
  'ft3/s': [0.0283168, 0, 'm3/s'],
  'ft3/hr': [0.00000786579, 0, 'm3/s'],
  'ft3/day': [0.000000327741, 0, 'm3/s'],
  'gpm': [0.00006309, 0, 'm3/s'],
  'gph': [0.000001052, 0, 'm3/s'],
  'gpd': [0.0000000438126363888887, 0, 'm3/s'], // // value updated by anitha
  // 'gpd': [0.00000004381, 0, 'm3/s'],
  'Bbl/hr': [0.0000441631, 0, 'm3/s'],
  'Bbl/day': [0.00000184013, 0, 'm3/s'],
  'l/s': [0.001, 0, 'm3/s'],
  'l/min': [0.0000166666666666667, 0, 'm3/s'],
  'l/hr': [2.77777777777778E-07, 0, 'm3/s'],
  'ft3/min': [0.000471947, 0, 'm3/s'],
  'm3/hr': [0.000277777777777778, 0, 'm3/s'],
  'm3/day': [0.0000115740740740741, 0, 'm3/s'],
  'm/s': [1.0, 0, 'm/s'],
  'lmh': [2.77777777778E-07, 0, 'm/s'],
  'lmd': [1.15741E-08, 0, 'm/s'],
  'gfd': [4.71595E-07, 0, 'm/s'],
  'm/hr': [0.000277777777777778, 0, 'm/s'],
  'm3': [1.0, 0, 'm3'],
  'l': [0.001, 0, 'm3'],
  'gal': [0.00378541, 0, 'm3'],
  'ft3': [0.0283168, 0, 'm3'],
  'kW': [1.0, 0, 'kW'],
  'hp': [0.7457, 0, 'kW'],
  'MW': [1000, 0, 'kW'],
  'W': [0.001, 0, 'kW']
};

const dic_wout = {
  '°C': [1.0, 0, '°C'],
  '°F': [1.8, 32.0, '°C'],
  'atm': [1.0, 0, 'atm'],
  'lbf/ft2': [2116.21848686146, 0, 'atm'],
  'psi': [14.696, 0, 'atm'],
  'ft H2O': [33.8994542187871, 0, 'atm'],
  'in H2O': [407.18933489694, 0, 'atm'],
  'in Hg': [29.9212435661575, 0, 'atm'],
  'mm Hg': [760.002100178515, 0, 'atm'],
  'kgf/cm2': [1.03322745279989, 0, 'atm'],
  'kgf/m2': [10332.2745279989, 0, 'atm'],  // new unit for pressure by Abhishek
  'bar': [1.01325, 0, 'atm'],
  'kPa': [101.325, 0, 'atm'],
  'MPa': [0.101325, 0, 'atm'],
  'm3/s': [1.0, 0, 'm3/s'],
  'ft3/s': [35.3147248276641, 0, 'm3/s'],
  'ft3/hr': [127132.811834539, 0, 'm3/s'],
  'ft3/day': [3051189.81146698, 0, 'm3/s'],
  'gpm': [15850.3724837534, 0, 'm3/s'],
  'gph': [950570.342205323, 0, 'm3/s'],
  // 'gpd': [22825838.8495777, 0, 'm3/s'],
  'gpd': [22824465.3237441, 0, 'm3/s'], // // value updated by anitha
  'Bbl/hr': [22643.3379903132, 0, 'm3/s'],
  'Bbl/day': [543439.865661665, 0, 'm3/s'],
  'l/s': [1000, 0, 'm3/s'],
  'l/min': [60000, 0, 'm3/s'],
  'l/hr': [3600000, 0, 'm3/s'],
  'ft3/min': [2118.88199310516, 0, 'm3/s'],
  'm3/hr': [3600, 0, 'm3/s'],
  'm3/day': [86400, 0, 'm3/s'],
  'm/s': [1.0, 0, 'm/s'],
  'lmh': [3600000, 0, 'm/s'],
  'lmd': [86400000, 0, 'm/s'],
  'gfd': [2120462.094, 0, 'm/s'],
  'm/hr': [3600, 0, 'm/s'],
  'm3': [1.0, 0, 'm3'],
  'l': [1000, 0, 'm3'],
  'gal': [264.172176857989, 0, 'm3'],
  'ft3': [35.3147248276641, 0, 'm3'],
  'kW': [1.0, 0, 'kW'],
  'hp': [1.3410218586563, 0, 'kW'],
  'MW': [0.001, 0, 'kW'],
  'W': [1000, 0, 'kW']
};
// old data
/* const dic_win = {
  '°C': [1.0, 0, '°C'],
  '°F': [0.55555555, -17.77777777, '°C'],
  'atm': [1.0, 0, 'atm'],
  'lbf/ft2': [0.000472541, 0, 'atm'],
  'psi': [0.0680457267283615, 0, 'atm'],
  'ft H2O': [0.029499, 0, 'atm'],
  'in H2O': [0.00245586, 0, 'atm'],
  'in Hg': [0.0334210708117444, 0, 'atm'],
  'mm Hg': [0.00131578583765112, 0, 'atm'],
  'kgf/cm2': [0.967841105354059, 0, 'atm'],
  'bar': [0.986923266716013, 0, 'atm'],
  'kPa': [0.00986923266716013, 0, 'atm'],
  'MPa': [9.86923266716013, 0, 'atm'],
  'm3/s': [1.0, 0, 'm3/s'],
  'ft3/s': [0.0283168, 0, 'm3/s'],
  'ft3/hr': [0.00000786579, 0, 'm3/s'],
  'ft3/day': [0.000000327741, 0, 'm3/s'],
  'gpm': [0.00006309, 0, 'm3/s'],
  'gph': [0.000001052, 0, 'm3/s'],
  'gpd': [0.00000004381, 0, 'm3/s'],
  'Bbl/hr': [0.0000441631, 0, 'm3/s'],
  'Bbl/day': [0.00000184013, 0, 'm3/s'],
  'l/s': [0.001, 0, 'm3/s'],
  'l/min': [0.0000166666666666667, 0, 'm3/s'],
  'l/hr': [2.77777777777778e-7, 0, 'm3/s'],
  'ft3/min': [0.000471947, 0, 'm3/s'],
  'm3/hr': [0.000277777777777778, 0, 'm3/s'],
  'm3/day': [0.0000115740740740741, 0, 'm3/s'],
  'm/s': [1.0, 0, 'm/s'],
  'lmh': [2.58670182898746e-8, 0, 'm/s'],
  'lmd': [1.07779242874478e-9, 0, 'm/s'],
  'gfd': [4.38126723153505e-8, 0, 'm/s'],
  'm/hr': [0.000277777777777778, 0, 'm/s'],
  'm3': [1.0, 0, 'm3'],
  'l': [0.001, 0, 'm3'],
  'gal': [0.00378541, 0, 'm3'],
  'ft3': [0.0283168, 0, 'm3'],
  'kW': [1.0, 0, 'kW'],
  'hp': [0.7457, 0, 'kW'],
  'MW': [1000, 0, 'kW'],
  'W': [0.001, 0, 'kW'],
};
const dic_wout = {
  '°C': [1.0, 0, '°C'],
  '°F': [1.8, 32.0, '°C'],
  'atm': [1.0, 0, 'atm'],
  'lbf/ft2': [2116.21848686146, 0, 'atm'],
  'psi': [14.696, 0, 'atm'],
  'ft H2O': [33.8994542187871, 0, 'atm'],
  'in H2O': [407.18933489694, 0, 'atm'],
  'in Hg': [29.9212435661575, 0, 'atm'],
  'mm Hg': [760.002100178515, 0, 'atm'],
  'kgf/cm2': [1.03322745279989, 0, 'atm'],
  'bar': [1.01325, 0, 'atm'],
  'kPa': [101.325, 0, 'atm'],
  'MPa': [0.101325, 0, 'atm'],
  'm3/s': [1.0, 0, 'm3/s'],
  'ft3/s': [35.3147248276641, 0, 'm3/s'],
  'ft3/hr': [127132.811834539, 0, 'm3/s'],
  'ft3/day': [3051189.81146698, 0, 'm3/s'],
  'gpm': [15850.3724837534, 0, 'm3/s'],
  'gph': [950570.342205323, 0, 'm3/s'],
  'gpd': [22825838.8495777, 0, 'm3/s'],
  'Bbl/hr': [22643.3379903132, 0, 'm3/s'],
  'Bbl/day': [543439.865661665, 0, 'm3/s'],
  'l/s': [1000, 0, 'm3/s'],
  'l/min': [60000, 0, 'm3/s'],
  'l/hr': [3600000, 0, 'm3/s'],
  'ft3/min': [2118.88199310516, 0, 'm3/s'],
  'm3/hr': [3600, 0, 'm3/s'],
  'm3/day': [86400, 0, 'm3/s'],
  'm/s': [1.0, 0, 'm/s'],
  'lmh': [38659268.2926829, 0, 'm/s'],
  'lmd': [927822439.02439, 0, 'm/s'],
  'gfd': [22824446.61, 0, 'm/s'],
  'm/hr': [3600, 0, 'm/s'],
  'm3': [1.0, 0, 'm3'],
  'l': [1000, 0, 'm3'],
  'gal': [264.172176857989, 0, 'm3'],
  'ft3': [35.3147248276641, 0, 'm3'],
  'kW': [1.0, 0, 'kW'],
  'hp': [1.3410218586563, 0, 'kW'],
  'MW': [0.001, 0, 'kW'],
  'W': [1000, 0, 'kW']
}; */

export const convertUnitValues = (floatin, unit) => {
  const formula = dic_win[unit];
  const inunit = formula[2];
  const multiplier_in = dic_wout[inunit][0];
  const constant_in = dic_wout[inunit][1];

  const multiplier_out = formula[0];
  const constant_out = formula[1];
  let floatOut = floatin * multiplier_in + constant_in;
  floatOut = (floatOut - constant_out) / multiplier_out;
  return decimalFormatter(floatOut, 2);
};

export const convertUnitValues_flow = (floatin, fromUnit, toUnit) => {
  const fromUnit_m3perSec = floatin * dic_win[fromUnit][0];
  const m3perSec_toUnit = fromUnit_m3perSec * dic_wout[toUnit][0];
  return m3perSec_toUnit;
};
export const convertUnitValues_pressure = (floatin, fromUnit, toUnit) => {
  const fromUnit_atm = floatin * dic_win[fromUnit][0];
  const atm_toUnit = fromUnit_atm * dic_wout[toUnit][0];
  return decimalFormatter(atm_toUnit, 4);  // updated by Abhishek 0n 17-April-24
};
export const convertUnitValues_flux = (floatin, fromUnit, toUnit) => {
  const fromUnit_ms = floatin * dic_win[fromUnit][0];
  const ms_toUnit = fromUnit_ms * dic_wout[toUnit][0];
  return ms_toUnit;
};

export const convertUnitValues_power = (floatin, fromUnit, toUnit) => {
  const fromUnit_kW = floatin * dic_win[fromUnit][0];
  const kW_toUnit = fromUnit_kW * dic_wout[toUnit][0];
  return decimalFormatter(kW_toUnit, 2);
};

export const convertUnitValues_volume = (floatin, fromUnit, toUnit) => {
  const fromUnit_m3 = floatin * dic_win[fromUnit][0];
  const m3_toUnit = fromUnit_m3 * dic_wout[toUnit][0];
  // return decimalFormatter(m3_toUnit, 3);
  return m3_toUnit;
};

export const convertUnitValues_temp = (floatin, fromUnit, toUnit) => {
  const fromUnit_degC = floatin * dic_win[fromUnit][0] + dic_win[fromUnit][1];
  const degC_toUnit = fromUnit_degC * dic_wout[toUnit][0] + dic_wout[toUnit][1];
  return decimalFormatter(degC_toUnit, 2);
};

// const roUnits = [
//   {unitFrom: 'm3/sec', unitTo: 'Bbl/hr', multiplier: 22643.318677848},
// ];

// const roUnitConvertion = (options = {}) => {
//   const { unitFrom, unitTo, value } = options;

// };

export default convertUnitValues;
